var bighouse = bighouse || {};

bighouse.lightboxTour = (function () {

    function init(){

        $('.js-lightboxTour').on('click', function(e){
            bighouse.lightbox.lightboxOpenFunc(e);
        });
    }


    return {
        init: init
    };
})();